import { getRequest, postRequest, putRequest, URL } from "shared/utils";

import {
  GET_USER,
  GET_USERS,
  GET_USER_CLIENTS,
  GET_USER_LIST,
  GET_USER_ROLES_V2,
  GET_USER_ASSIGNED_CLIENTS,
  GET_USER_DETAILS,
  ARCHIVE_USER,
  UNARCHIVE_USER,
  INSERT_USER,
  UPDATE_USER,
  TRACK_USER_ACTIVITY,
  USER_LOGOUT,
  GET_USER_NOTIFICATIONS,
  MARK_NOTIFICATIONS_AS_READ,
  SET_SELECTED_NOTIFICATION_COMMENT,
  RESET_SELECTED_NOTIFICATION_COMMENT,
  GET_UNREAD_NOTIFICATION_COUNT,
  RESET_NOTIFICATIONS,
  GET_USER_SETTINGS,
  UPDATE_USER_SETTINGS,
  GET_USER_DEFAULT_SETTINGS,
  GET_NOTIFICATION_BY_ID,
  UPDATE_EXCLUDE_PRE_TRANSACTION,
  GET_EXCLUDE_PRE_TRANSACTION,
} from "./actionTypes";

const queryParms = (request) => {
  const { searchKeyword, filters } = request;

  let parms = ``;

  if (searchKeyword) {
    parms += `&searchKeyword=${searchKeyword}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key, index) => {
      var filterBy = filters[key];

      if (key === "OnlyAdmins" && filterBy) {
        parms += `&${key}=true`;
      }

      if (filterBy && filterBy.length > 0) {
        filterBy.forEach((f) => {
          parms += `&${key}=${f}`;
        });
      }
    });
  }
  return parms;
};

const notificationQueryParams = (request) => {
  let parms = ``;
  parms += `?userId=${request.userId}&clientId=${request.clientId}&pageNumber=${
    request.pageNumber
  }&pageSize=${20}&readUnread=${request.readUnread}&notificationType=${
    request.notificationType
  }`;
  return parms;
};

export function getUser(userEmailAddress) {
  const url = `${URL.user}/user?userEmailAddress=${userEmailAddress}`;

  const request = getRequest(url);

  return {
    type: GET_USER,
    payload: request,
  };
}

export function getUserDetails(userId) {
  const url = `${URL.user}/${userId}`;

  const request = getRequest(url);

  return {
    type: GET_USER_DETAILS,
    payload: request,
  };
}

export function getUsers() {
  const url = `${URL.user}`;

  const request = getRequest(url);

  return {
    type: GET_USERS,
    payload: request,
  };
}

export function insertUser(user) {
  const url = `${URL.user}`;

  const request = postRequest(url, user);

  return {
    type: INSERT_USER,
    payload: request,
  };
}

export function updateUser(user) {
  const url = `${URL.user}`;

  const request = putRequest(url, user);

  return {
    type: UPDATE_USER,
    payload: request,
  };
}

export function getUsersList(requestParams) {
  const url = `${URL.user}?${queryParms(requestParams)}`;

  const request = getRequest(url);

  return {
    type: GET_USER_LIST,
    payload: request,
  };
}

export function getUserClients(userEmailAddress) {
  const url = `${URL.user}/email/${userEmailAddress}/clients`;

  const request = getRequest(url);

  return {
    type: GET_USER_CLIENTS,
    payload: request,
  };
}

export function getUserAssignedClients(userId) {
  const url = `${URL.user}/${userId}/clients`;

  const request = getRequest(url);

  return {
    type: GET_USER_ASSIGNED_CLIENTS,
    payload: request,
  };
}

export function getUserRolesV2() {
  const url = `${URL.user}/roles/v2`;

  const request = getRequest(url);

  return {
    type: GET_USER_ROLES_V2,
    payload: request,
  };
}

export function archiveUser(userId, modifiedBy) {
  const url = `${URL.user}/${userId}/archive?modifiedBy=${modifiedBy}`;

  const request = putRequest(url);

  return {
    type: ARCHIVE_USER,
    payload: request,
  };
}

export function unArchiveUser(userId, modifiedBy) {
  const url = `${URL.user}/${userId}/unarchive?modifiedBy=${modifiedBy}`;

  const request = putRequest(url);

  return {
    type: UNARCHIVE_USER,
    payload: request,
  };
}

export function trackUserActivity(request) {
  const url = `${URL.user}/userAnalytics`;

  var postReq = postRequest(url, request); //, true);

  return {
    type: TRACK_USER_ACTIVITY,
    payload: postReq,
  };
}

export function userLogout() {
  return {
    type: USER_LOGOUT,
  };
}

export function getNotifications(requestParams) {
  const url = `${URL.notifications}${notificationQueryParams(requestParams)}`;
  const request = getRequest(url);

  return {
    type: GET_USER_NOTIFICATIONS,
    payload: request,
  };
}

export function MarkNotificationsAsRead(userId, notificationId) {
  let url = `${URL.notifications}/${userId}/markAsRead`;
  if (notificationId !== null) {
    url += `?notificationId=${notificationId}`;
  }
  return postRequest(url).then(() => ({
    type: MARK_NOTIFICATIONS_AS_READ,
    payload: { notificationId: notificationId },
  }));
}

export function getUnreadNotificationCount(userId, clientId) {
  let url = `${URL.notifications}/unreadCount?userId=${userId}&clientId=${clientId}`;
  const request = getRequest(url);

  return {
    type: GET_UNREAD_NOTIFICATION_COUNT,
    payload: request,
  };
}

export function setSelectedNotificationComment(notification) {
  return {
    type: SET_SELECTED_NOTIFICATION_COMMENT,
    payload: { notification },
  };
}

export function resetSelectedNotificationComment() {
  return {
    type: RESET_SELECTED_NOTIFICATION_COMMENT,
    payload: { notification: null },
  };
}

export function resetNotifications() {
  return {
    type: RESET_NOTIFICATIONS,
    payload: { notification: [] },
  };
}

export function getUserSettings(userId, clientId) {
  let url = `${URL.userSettings}?userId=${userId}&clientId=${clientId}`;
  const request = getRequest(url);

  return {
    type: GET_USER_SETTINGS,
    payload: request,
  };
}

export function updateUserSettings(data) {
  const url = `${URL.userSettings}/userSettings`;
  const request =  postRequest(url, data);
  return {
    type: UPDATE_USER_SETTINGS,
    payload: request
  };
}

export function updateReadOnly(data) {
  const url = `${URL.userSettings}/update-readonly`;
  const request =  postRequest(url, data);
  return {
    type: UPDATE_USER_SETTINGS,
    payload: request
  };
}

export function getUserDefaultSettings(userId, clientId) {
  let url = `${URL.userSettings}/defaultSettings?userId=${userId}&clientId=${clientId}`;
  const request = getRequest(url);

  return {
    type: GET_USER_DEFAULT_SETTINGS,
    payload: request,
  };
}

export function updateExcludePreTransaction(clientId, excludePreTransaction, userEmail) {
  const url = `${URL.userSettings}/excludePreTransaction?clientId=${clientId}&excludePreTransaction=${excludePreTransaction}&userEmail=${userEmail}`;

  const request = putRequest(url);

  return {
    type: UPDATE_EXCLUDE_PRE_TRANSACTION,
    payload: request,
  };
}

export function getExcludePreTransaction(userId, clientId) {
  const url = `${URL.userSettings}/excludePreTransaction?userId=${userId}&clientId=${clientId}`;
  
  const request = getRequest(url);
  return {
    type: GET_EXCLUDE_PRE_TRANSACTION,
    payload: request,
  };
}

export function getNotificationById(notificationId) {
  let url = `${URL.notifications}/getNotificationById/?notificationId=${notificationId}`;
  const request = getRequest(url);

  return {
    type: GET_NOTIFICATION_BY_ID,
    payload: request,
  };
}